import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { th } from 'date-fns/locale';
import { get } from 'http';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent implements OnInit {


  // Temporal aggregation, it could be month or date
  @Input() temporalAggr: 'month' | 'day' = 'month';
  @Input() isRange: boolean = false;

  // Range min and max dates
  minDate: string = new Date().toISOString();
  maxDate: string = new Date().toISOString();

  // Range values
  rangeMinValue: number = 0;
  rangeMaxValue: number = 10;
  rangeValue: number | { lower: number, upper: number };

  // Event emitted when the range value changes
  @Output() onChange: EventEmitter<Date | { minDate: Date, maxDate: Date }> = new EventEmitter<Date | { minDate: Date, maxDate: Date }>();

  constructor() {
    this.rangeValue = 0;
    if (this.isRange) this.rangeValue = { lower: 0, upper: 10 };
    this.initDates();
  }

  ngOnInit() { }


  initDates() {
    // First add the max and min values
    let now = new Date();
    // Set the day to the first day of the month
    now.setDate(1);
    // Init the min and max dates
    let minDate = new Date(now.getTime());
    let maxDate = new Date(now.getTime());
    // Set the min and max values
    minDate.setFullYear(now.getFullYear() - 20);
    this.minDate = minDate.toISOString();
    maxDate.setMonth(now.getMonth() + 6);
    this.maxDate = maxDate.toISOString();

    this.recalculateRangeMaxMin();
  }

  /**
   * Calculates the range values
   * @param event 
   */
  recalculateRangeMaxMin() {
    if (!this.minDate || !this.maxDate) return;
    if (this.temporalAggr == 'month') {
      this.rangeMaxValue = this.monthDiff(new Date(this.minDate), new Date(this.maxDate));
      this.rangeValue = this.getDefaultValue();
    } else {
      this.rangeMaxValue = this.daysDiff(new Date(this.minDate), new Date(this.maxDate));
      this.rangeValue = this.getDefaultValue();
    }
    this.rangeMinValue = 0;
    console.debug('DateRangeComponent: recalculateRangeMaxMin', this.rangeMinValue, this.rangeMaxValue, this.rangeValue);
  }


  /**
   * Calculates the default value for the range
   * @returns the default value for the range
   */
  getDefaultValue() {

    let now = new Date();
    if(new Date(this.maxDate) < now) now = new Date(this.maxDate);
    else if (now < new Date(this.minDate)) now = new Date(this.maxDate);

    this.monthDiff(new Date(this.minDate), new Date());

    let valueToReturn: any = 0;

    if (this.isRange) {
      let lowerDate = new Date(now.getTime());
      lowerDate.setMonth(now.getMonth() - 6);
      let upperDate = now;
      if (this.temporalAggr == 'day') {
        valueToReturn = {
          lower: this.daysDiff(new Date(this.minDate), lowerDate),
          upper: this.daysDiff(new Date(this.minDate), upperDate)
        };
      } else {
        valueToReturn = {
          lower: this.monthDiff(new Date(this.minDate), lowerDate),
          upper: this.monthDiff(new Date(this.minDate), upperDate)
        };
      }
    } else {
      if (this.temporalAggr == 'day') {
        valueToReturn = this.daysDiff(new Date(this.minDate), now);
      } else {
        valueToReturn = this.monthDiff(new Date(this.minDate), now);
      }
    }
    return valueToReturn;
  }

  /**
   * Converts the range value to a date
   * @param value 
   * @returns 
   */
  convertValueToDate(value: number) {
    let currentDateValue = new Date(this.minDate);
    if (this.temporalAggr == 'month') {
      currentDateValue.setMonth(currentDateValue.getMonth() + value);
    } else {
      currentDateValue = new Date(currentDateValue.setDate(currentDateValue.getDate() + value));
    }
    return currentDateValue;
  }

  /**
   * Method used to format the value of the pin inside the range
   * @param value 
   * @returns 
   */
  dateValueFormatter = (value: number) => {
    let currentDateValue = this.convertValueToDate(value);
    return this.dateFormater(currentDateValue);
  }

  /**
   * Method used to convert date to string
   * @param date 
   * @returns 
   */
  dateFormater(date: Date | string) {
    if (typeof date == 'string') date = new Date(date);
    return date.toISOString().split('T')[0];
  }

  /**
   * Calculates the number of months between two dates
   * @param d1 
   * @param d2 
   * @returns 
   */
  monthDiff(d1: Date, d2: Date) {
    let months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  /**
   * Calculates the number of days between two dates
   * @param d1 
   * @param d2 
   */
  daysDiff(d1: Date, d2: Date) {
    let timeDiff = Math.abs(d2.getTime() - d1.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }


  onRangeChange(event: any) {
    let valueToEmit: any = new Date();
    if (this.isRange) {
      valueToEmit = {
        minDate: this.convertValueToDate(event.detail.value.lower),
        maxDate: this.convertValueToDate(event.detail.value.upper)
      };
    } else {
      valueToEmit = this.convertValueToDate(event.detail.value);
    }
    this.onChange.emit(valueToEmit);
  }

  changeRangeLimit(limit: 'min'|'max', event: any) {
    if(limit == 'min') this.minDate = event.detail.value;
    else this.maxDate = event.detail.value;
    this.recalculateRangeMaxMin();
  }

}
